var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgileProcessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0772 46.2762L3.946 38.1449C2.22963 36.4286 2.01104 33.7209 3.42984 31.7514L5.28149 29.1811C6.34183 27.7092 7.63763 26.4222 9.11675 25.372L12.8693 22.7076C14.1818 21.7757 15.9751 21.9266 17.1133 23.0648L18.6133 24.5649L25.743 31.6946L27.1573 33.1089C28.2955 34.2471 28.4465 36.0404 27.5146 37.3528L24.8501 41.1054C23.7999 42.5845 22.513 43.8803 21.0411 44.9407L18.4708 46.7923C16.5013 48.2111 13.7936 47.9925 12.0772 46.2762Z",
    fill: "#FCFF74",
    stroke: "#020202",
    strokeWidth: 2.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2058 12.1553L38.0746 4.02412C36.3583 2.30776 33.6506 2.08916 31.6811 3.50797L29.1108 5.35962C27.6389 6.41996 26.3519 7.71576 25.3017 9.19487L22.6373 12.9474C21.7054 14.2599 21.8563 16.0532 22.9945 17.1914L24.4945 18.6914L31.6243 25.8211L33.0386 27.2354C34.1768 28.3736 35.9701 28.5246 37.2825 27.5927L41.0351 24.9283C42.5142 23.878 43.81 22.5911 44.8704 21.1192L46.722 18.5489C48.1408 16.5794 47.9222 13.8717 46.2058 12.1553Z",
    fill: "#FCFF74"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2058 12.1553L38.0746 4.02412C36.3583 2.30776 33.6506 2.08916 31.6811 3.50797L29.1108 5.35962C27.6389 6.41996 26.3519 7.71576 25.3017 9.19487L22.6373 12.9474C21.7054 14.2599 21.8563 16.0532 22.9945 17.1914L24.4945 18.6914L31.6243 25.8211L33.0386 27.2354C34.1768 28.3736 35.9701 28.5246 37.2825 27.5927L41.0351 24.9283C42.5142 23.878 43.81 22.5911 44.8704 21.1192L46.722 18.5489C48.1408 16.5794 47.9222 13.8717 46.2058 12.1553Z",
    stroke: "#020202",
    strokeWidth: 2.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7232 18.5L18.457 31.7662",
    stroke: "#020202",
    strokeWidth: 2.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgileProcessIcon);
export default __webpack_public_path__ + "static/media/agile-process-icon.b6f8a270f4980c742c97e6d7f7b569af.svg";
export { ForwardRef as ReactComponent };